import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import DownloadButton from 'components/controls/DownloadButton';
import styles from './InfoCarouselItem.scss';

export default function InfoCarouselItem(props) {
  const { position, text, className } = props;
  return (
    <div className={classnames(styles.container, className)}>
      <div className={styles.downloadButtonWrapper}>
        <DownloadButton className={styles.downloadButton} />
      </div>
      <div className={styles.position}>{`${position + 1}/${4}`}</div>
      <div className={styles.text}>{text}</div>
      <div className={styles.mobileDownloadButtonWrapper}>
        <DownloadButton className={styles.mobileDownloadButton} />
      </div>
    </div>
  );
}

InfoCarouselItem.propTypes = {
  position: PropTypes.number,
  text: PropTypes.string,
  className: PropTypes.string,
};

InfoCarouselItem.defaultProps = {
  position: 0,
  text: '',
  className: '',
};



// WEBPACK FOOTER //
// ./src/components/IndexPage/InfoCarouselItem.jsx